export default class PlateInfo{
  public procedure:  string = '';

  public city:  string = '';

  public uf:  string = '';

  public plate:  string = '';

  public chassis:  string = '';

  public chassisSituation:  string = '';

  public branchModel:  string = '';

  public batteryCapacity:  string = '';

  public fuel:  string = '';

  public color:  string = '';

  public power:  number = 0;

  public cylinders:  number = 0;

  public quantityPassenger:  number = 0;

  public montageType:  string = '';

  public axiosQuantity:  number = 0;

  public pbt:  number = 0;

  public cmt:  number = 0;

  public vehicleType:  string = '';

  public bodyworkType:  string = '';

  public motorNumber:  string = '';

  public gearBox:  string = '';

  public rearDifAxisNumber:  string = '';

  public bodywork:  string = '';

  constructor(data: any = {}) {
    this.procedure = data.procedure || '';
    this.city = data.city || '';
    this.uf = data.uf || '';
    this.plate = data.plate || '';
    this.chassis = data.chassis || '';
    this.chassisSituation = data.chassis_situation || '';
    this.branchModel = data.branch_model || '';
    this.batteryCapacity = data.battery_capacity || '';
    this.fuel = data.fuel || '';
    this.color = data.color || '';
    this.power = data.power || '';
    this.cylinders = data.cylinders || '';
    this.quantityPassenger = data.quantity_passenger || '';
    this.montageType = data.montage_type || '';
    this.axiosQuantity = data.axios_quantity || '';
    this.pbt = data.pbt || '';
    this.cmt = data.cmt || '';
    this.vehicleType = data.vehicle_type || '';
    this.bodyworkType = data.bodywork_type || '';
    this.motorNumber = data.motor_number || '';
    this.gearBox = data.gear_box || '';
    this.rearDifAxisNumber = data.rear_dif_axis_number || '';
    this.bodywork = data.bodywork || '';
  }
}
